export const tr = {
    'about-price': 'Reklamlardaki fiyatlar hakkında daha fazla bilgi',
    'editor-cancel-action': 'İptal',
    'editor-clear-fields-action': 'Alanları temizle',
    'editor-save-action': 'Kaydet',
    'price-hint-text':
        'Ürün galerisine girmek için ürününüzün fiyatını belirtin. Görselleri yüklemeyi unutmayın. {helpUrl}'
};
